import Seo from "@/components/Seo";
import { Reveal, Eyebrow } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Products and pricing",
    body: "We work to display product descriptions, images, availability and prices accurately. Genuine errors may occasionally occur. We may correct an error or cancel an affected order. If payment has already been taken for a cancelled order, a full refund will be issued.",
  },
  {
    title: "Orders",
    body: "Orders are subject to acceptance and availability. We may cancel or decline an order where an item is unavailable, materially mispriced, cannot be shipped to the destination, or where fraud is reasonably suspected.",
  },
  {
    title: "Payment",
    body: "Payments are processed securely through Shopify checkout and the payment methods made available there.",
  },
  {
    title: "Shipping and returns",
    body: "Delivery estimates, shipping costs and returns are governed by our Shipping Policy and Refund Policy. Nothing in these terms limits any rights you may have under applicable consumer law.",
  },
  {
    title: "Intellectual property",
    body: "Branding, copy, design, imagery and other content on the site belong to Weird O'Clock or its content partners and may not be reused without permission except as permitted by law.",
  },
  {
    title: "Liability",
    body: "To the maximum extent permitted by law, we are not liable for indirect or consequential loss arising from use of the website or products. Nothing in these terms excludes rights or remedies that cannot legally be excluded, including rights under the Australian Consumer Law.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of New South Wales, Australia. Nothing in these terms limits rights you may have under applicable consumer law.",
  },
  {
    title: "Business contact",
    body: "Weird O'Clock — Australian owned and operated. Contact us through the Contact page or at sorellinabali@gmail.com.",
  },
];

export default function TermsPage() {
  return (
    <main data-testid="terms-page" className="min-h-screen bg-void pt-28 sm:pt-32">
      <Seo
        title="Terms of Service — Weird O'Clock"
        siteName="Weird O'Clock"
        description="The terms of using and buying from Weird O'Clock, governed by the laws of New South Wales, Australia."
      />
      <div className="mx-auto max-w-[900px] px-5 pb-24 sm:px-8">
        <Reveal>
          <Eyebrow>The fine print, minus the fine print energy</Eyebrow>
          <h1 className="font-display text-4xl font-black tracking-tight text-ivory sm:text-5xl lg:text-6xl">
            Terms of <span className="font-editorial italic text-amber">service</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-ivory/60">
            These terms apply when you browse or purchase from Weird O'Clock.
            By placing an order, you agree to these terms together with our
            Shipping Policy, Refund Policy and Privacy Policy.
          </p>
        </Reveal>
        <div className="mt-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.04}>
              <div data-testid={`terms-section-${i}`} className="border-t border-white/10 py-8">
                <h2 className="font-display text-lg font-bold text-ivory sm:text-xl">{s.title}</h2>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-ivory/50 sm:text-base">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </main>
  );
}
